import { render, staticRenderFns } from "./AirQualityComparisionPanel.vue?vue&type=template&id=4283d550"
import script from "./AirQualityComparisionPanel.vue?vue&type=script&lang=js"
export * from "./AirQualityComparisionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports